import { render, staticRenderFns } from "./customerAttachements.vue?vue&type=template&id=ef9fd362"
import script from "./customerAttachements.ts?vue&type=script&lang=js&external"
export * from "./customerAttachements.ts?vue&type=script&lang=js&external"
import style0 from "./customerAttachements.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports